// extracted by mini-css-extract-plugin
export default {"FinishedQuiz":"FinishedQuiz_FinishedQuiz__A9BJA","success":"FinishedQuiz_success__M7O5a","error":"FinishedQuiz_error__xY2HF"};